export interface TableSortSettings {
  column: string
  reverse: boolean
}

export interface Settings {
  tables_sorted_by: {
    [key: string]: TableSortSettings
  }
}

const SETTINGS_KEY = 'settings.json'

/**
 * Get all settings from localStorage
 */
export const getSettings = (): Settings => {
  try {
    const stored = localStorage.getItem(SETTINGS_KEY)
    if (stored) {
      return JSON.parse(stored)
    }
  } catch (error) {
    console.error('Error reading settings from localStorage:', error)
  }
  return { tables_sorted_by: {} }
}

/**
 * Save all settings to localStorage
 */
export const saveSettings = (settings: Settings): void => {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings))
  } catch (error) {
    console.error('Error saving settings to localStorage:', error)
  }
}

/**
 * Get table sort settings for a specific table
 */
export const getTableSortSettings = (
  page: string,
  tableName: string
): TableSortSettings | null => {
  const settings = getSettings()
  const key = `${page}:${tableName}`
  return settings.tables_sorted_by[key] || null
}

/**
 * Save table sort settings for a specific table
 */
export const saveTableSortSettings = (
  page: string,
  tableName: string,
  sortSettings: TableSortSettings
): void => {
  const settings = getSettings()
  const key = `${page}:${tableName}`
  settings.tables_sorted_by[key] = sortSettings
  saveSettings(settings)
}

/**
 * Clear table sort settings for a specific table
 */
export const clearTableSortSettings = (
  page: string,
  tableName: string
): void => {
  const settings = getSettings()
  const key = `${page}:${tableName}`
  delete settings.tables_sorted_by[key]
  saveSettings(settings)
}


